'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgPlay = (props) => (React__namespace.createElement("svg", Object.assign({ width: 21, height: 20, viewBox: "0 0 21 20", fill: "none" }, props),
    React__namespace.createElement("path", { d: "M10.128 5.17185L13.2099 7.22646C15.0915 8.48081 16.0322 9.10799 16.0322 9.99996C16.0322 10.8919 15.0915 11.5191 13.2099 12.7735L10.128 14.8281C7.84678 16.3489 6.70616 17.1093 5.82592 16.6382C4.94569 16.1671 4.94569 14.7963 4.94569 12.0546V7.94535C4.94569 5.20364 4.94569 3.83279 5.82592 3.3617C6.70616 2.89061 7.84678 3.65102 10.128 5.17185Z", fill: props.fillColor, fillOpacity: 0.6 })));

exports.default = SvgPlay;
//# sourceMappingURL=Play.js.map
